import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table, Loader} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import UsersTable from './usersTable';
import './styles.scss';

class UserModification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'statusFilter': 'ALL',
    };
  }

  componentDidMount() {
    const {isUserFromTDE, dealerId} = this.props;
    const isTde = isUserFromTDE;

    this.props.fetchUsersList({dealerId, isTde});
  }

  componentWillUnmount() {
    this.props.clearUserRequests();
  }

  onChangeStatusFilter(value) {
    this.setState({...this.state, 'statusFilter': value});
  }

  getStatusFiltered(list) {
    if (this.state.statusFilter && this.state.statusFilter !== 'ALL') {
      const t = [...list.filter((x) => x.status === this.state.statusFilter)];
      return t;
    }
    return list;
  }

  renderLoaderOrUsers = () => {
    const {loading, list, isUserFromTDE, type} =
      this.props;

    if (loading) {
      return (
        <Table striped className="toyota-grid">
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan="100%">
                <Loader active inline="centered" content="Ejecutando" />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    }

    return (
      <UsersTable
        list={this.getStatusFiltered(list)}
        isUserFromTDE={isUserFromTDE}
        type={type}
        onChangeStatusFilter={this.onChangeStatusFilter.bind(this)}
        statusFilter={this.state.statusFilter}
      />
    );
  };

  render() {
    return (
      <div className="user-list-container">
        <div className="title-bar">
          <div className="title">
            <h3>Usuarios Concesionario</h3>
          </div>
        </div>
        <Card raised fluid>
          {this.renderLoaderOrUsers()}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'dealerId': state.session.dealerId,
    'loading': state.usersList.loading,
    'list': state.usersList.list,
    'isUserFromTDE': state.session.isUserFromTDE,
  };
};

const {fetchUsersList, clearUserRequests, navigateTo} = Actions;

export default connect(mapStateToProps, {
  fetchUsersList,
  clearUserRequests,
  navigateTo,
})(UserModification);
